import { TControlledFormComponentProps } from '@chocolate-soup-inc/cs-frontend-components';
import { TManufacturerProductIdType } from '../../generated/graphql';
import styles from '../../pages/shipments/PrintLabelModal/PrintLabelModal.module.scss';

export const getProductIdentifierFormFields = (): TControlledFormComponentProps[] => [
  {
    name: 'hsCode',
    label: 'HS Code',
    type: 'textField',
    inputOptions: {
      mask: ['0000{.}00{.}00']
    }
  },
  {
    name: 'description',
    label: 'Description',
    type: 'textField'
  },
  {
    name: 'quantity',
    label: 'Quantity',
    type: 'textField'
  },
  {
    name: 'value',
    label: 'Value',
    type: 'textField',
    inputOptions: {
      trailingIcon: <span className={styles.trailingText}>CAD</span>
    }
  },
  {
    name: 'country',
    label: 'Country of origin',
    type: 'countrySelect'
  },
  {
    name: 'originCriterion',
    label: 'Origin Criterion (USA)',
    type: 'textField'
  },
  {
    name: 'sku',
    label: 'Merchant Product ID (SKU)',
    type: 'textField'
  },
  {
    name: 'manufacturerNsProductId',
    label: 'Manufacturer Product ID',
    type: 'textField',
    inputOptions: {
      supportingText: "Manufacturer's code, part number, or model number."
    }
  },
  {
    name: 'manufacturerProductIdType',
    label: 'Standardized Product ID Type',
    type: 'select',
    inputOptions: {
      multiple: false,
      options: Object.values(TManufacturerProductIdType).map((value) => ({
        value,
        label: value === TManufacturerProductIdType.Undefined ? 'Other / unspecified' : value.toUpperCase()
      }))
    }
  },
  {
    name: 'manufacturerProductId',
    label: 'Standardized Product ID',
    type: 'textField',
    inputOptions: {
      supportingText: 'Identifier matching the selected type.'
    }
  }
];

export const getProductFormFields = () => {
  const formFields: TControlledFormComponentProps[] = [...getProductIdentifierFormFields()];

  return formFields;
};
